import React from 'react';
import { translate } from "../../Services/translation";
import Svg from "../../Components/Svg";

const FacetedSearchCompact = ({
    facetFilters,
    visibleDropdownMenu,
    closeDropdownMenu,
    toggleVisibleDropdownMenu,
    onFacetChange,
    onSubmit
}) => {
    return <ul className="faceted-search faceted-search--compact">
        {facetFilters && facetFilters.map((group, groupIndex, array) => group.options && group.options.length > 0 && (
            <li className="faceted-search__group" key={`${group.label}-${groupIndex}`}>
                <div
                    className={`faceted-search__group-header ${visibleDropdownMenu.includes(group.id) ? 'faceted-search__group-header--show-compact' : ''}`}
                    role="faceted-search-item-group" onClick={() => {
                        visibleDropdownMenu.includes(group.id) ?
                            closeDropdownMenu(group) :
                            toggleVisibleDropdownMenu(group);
                    }}>
                    {group.label}

                    <div className="faceted-search__group-header-chevron">
                        <Svg icon="chevron" extraClass="chevron-down" />
                    </div>
                </div>

                <ul className="faceted-search__sublist">
                    {group.options && group.options.map((item, itemIndex, array) => (
                        <li key={`${item.label}-${itemIndex}`} className="faceted-search__item"
                            role="faceted-search-item">
                            <FacetedFilterCheckbox item={item} group={group} onFacetChange={onFacetChange} />
                        </li>
                    ))}

                    <li className="faceted-search__item">
                        <button className="filter__button" onClick={event => {
                            toggleVisibleDropdownMenu(group);
                            onSubmit(facetFilters)
                        }}>{translate('general.select')}</button>
                    </li>
                </ul>
            </li>
        ))}
    </ul>
}

const FacetedFilterCheckbox = ({ item, group, onFacetChange }) => {
    const checked = group.selectedOptions.includes(item.id);

    return <label className="faceted-filter">
        <input className="faceted-filter__input" type="checkbox" onChange={event => onFacetChange(group, item)}
            checked={checked} />

        <div className="faceted-filter__pseudo-checkbox">
            {checked && <Svg icon="checkmark" />}
        </div>

        <span className="faceted-filter__label">
            {item.label}
            {!isNaN(item.quantity) &&
                <span className="faceted-filter__quantity"> ({item.quantity})</span>
            }
        </span>
    </label>
}

export default FacetedSearchCompact;
